import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { grayDark, grayDarker } from '@bufferapp/ui/style/colors'

import {
  Text,
  Modal,
  Form,
  FormSection,
  FormControls,
  FormControlsGroup,
  Checkbox,
  Button,
} from '~/shared/components'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
const Dialog = ({ children, withDontShowAgain, cancel, submit }) => {
  const { label: cancelLabel, handler: cancelHandler } = cancel
  const { label: submitLabel, handler: submitHandler } = submit

  const [dontShowAgainChecked, setDontShowAgainChecked] = useState(false)

  const onToggleDontShowAgain = useCallback(
    (event: any) => {
      event.stopPropagation()
      setDontShowAgainChecked(event.target.checked)
    },
    [setDontShowAgainChecked],
  )

  const onFormSubmit = useCallback(
    (event: any) => {
      event.preventDefault()
      event.stopPropagation()
      submitHandler(dontShowAgainChecked)
    },
    [dontShowAgainChecked],
  )

  return (
    <Modal onClose={cancelHandler}>
      <Form
        onSubmit={withDontShowAgain ? onFormSubmit : submitHandler}
        method="dialog"
      >
        {children}
        {/* @ts-expect-error TS(2741) FIXME: Property 'withBg' is missing in type '{ children: ... Remove this comment to see the full error message */}
        <FormSection>
          <FormControls spaced={!!withDontShowAgain}>
            {withDontShowAgain && (
              <FormControlsGroup>
                <Checkbox
                  id="dont-show-again"
                  name="dont-show-again"
                  value="dont-show-again"
                  checked={dontShowAgainChecked}
                  label="Don't show me this again"
                  onChange={onToggleDontShowAgain}
                  data-testid="control-dont-show-again"
                />
              </FormControlsGroup>
            )}
            <FormControlsGroup>
              {cancelLabel && (
                <Button
                  // @ts-expect-error TS(2322) FIXME: Type '{ type: string; variant: string; onClick: an... Remove this comment to see the full error message
                  type="button"
                  variant="text"
                  onClick={cancelHandler}
                  label={cancelLabel}
                  data-testid="control-cancel"
                />
              )}
              <Button
                // @ts-expect-error TS(2322) FIXME: Type '{ type: string; variant: string; label: any;... Remove this comment to see the full error message
                type="submit"
                variant="primary"
                label={submitLabel}
                data-testid="control-submit"
              />
            </FormControlsGroup>
          </FormControls>
        </FormSection>
      </Form>
    </Modal>
  )
}

Dialog.propTypes = {
  children: PropTypes.any.isRequired,
  withDontShowAgain: PropTypes.bool,
  cancel: PropTypes.shape({
    label: PropTypes.string,
    handler: PropTypes.func,
  }),
  submit: PropTypes.shape({
    label: PropTypes.string,
    handler: PropTypes.func,
  }),
}

Dialog.defaultProps = {
  withDontShowAgain: false,
  cancel: {},
  submit: {},
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
const Title = ({ children }) => (
  // @ts-expect-error TS(2741) FIXME: Property 'withBg' is missing in type '{ children: ... Remove this comment to see the full error message
  <FormSection>
    {/* @ts-expect-error TS(2741) FIXME: Property 'className' is missing in type '{ childre... Remove this comment to see the full error message */}
    <Text size={18} weight="bold" color={grayDarker}>
      {children}
    </Text>
  </FormSection>
)

Title.propTypes = {
  children: PropTypes.any.isRequired,
}

Title.defaultProps = {}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
const Message = ({ children }) => (
  <FormSection withBg>
    {/* @ts-expect-error TS(2741) FIXME: Property 'className' is missing in type '{ childre... Remove this comment to see the full error message */}
    <Text size={14} weight={400} color={grayDark}>
      {children}
    </Text>
  </FormSection>
)

Message.propTypes = {
  children: PropTypes.any.isRequired,
}

Message.defaultProps = {}

/**
 *
 */
Dialog.Title = Title
Dialog.Message = Message

export default Dialog
